/* Extracted 2026-10-13 from sections/announcement-bar.liquid blocks 6 and 9 (scroll reveal + masonry, wishlist hearts). Both guard on readyState/DOMContentLoaded, so defer is safe. SEO round 3, audit C1. */
(function () {
    'use strict';

    /* ① SCROLL REVEAL — Rituals cubic-bezier feel */
    function initScrollReveal() {
      if (!window.IntersectionObserver) return;
      /* Stretch theme uses li.collection-product-card, not product-card custom element */
      var cards = document.querySelectorAll('li.collection-product-card');
      if (!cards.length) return;
      cards.forEach(function (card, i) {
        card.classList.add('tlc-reveal-pending');
        card.style.transitionDelay = (i % 4 * 60) + 'ms';
      });
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('tlc-revealed');
          var t = e.target;
          setTimeout(function () {
            t.classList.remove('tlc-reveal-pending');
            t.style.transitionDelay = '';
          }, 650);
          obs.unobserve(e.target);
        });
      }, { threshold: 0.06, rootMargin: '0px 0px -30px 0px' });
      cards.forEach(function (c) { obs.observe(c); });
    }

    /* ② TRUE MASONRY — CSS grid-row-end spanning
       Batch reads before writes to avoid layout thrashing (each offsetHeight read
       after a style write forces a synchronous reflow). */
    function tlcMasonry() {
      if (!document.body.classList.contains('template-collection')) return;
      var grid = document.querySelector('ul.collection-product-list');
      if (!grid || window.innerWidth < 700) return;
      var cards = Array.from(grid.querySelectorAll('li.collection-product-card, .tlc-gwp-card'));
      /* Phase 1: read all heights (no writes — one reflow total) */
      var heights = cards.map(function (card) { return card.offsetHeight; });
      /* Phase 2: apply all writes (browser paints once) */
      requestAnimationFrame(function () {
        cards.forEach(function (card, i) {
          if (heights[i]) card.style.gridRowEnd = 'span ' + heights[i];
        });
      });
    }

    /* ③ GWP CARD — inject gift promo at 3rd position
       TLC 2026-07-16 — DISABLED by founder. Its gift-threshold claim contradicted
       the free-gift strip further down this same file, so the card no longer
       renders on any collection page. To restore: set the flag below to true. */
    var TLC_GWP_CARD_ENABLED = false;
    function injectGWPCard() {
      if (!TLC_GWP_CARD_ENABLED) return;
      if (!document.body.classList.contains('template-collection')) return;
      if (document.querySelector('.tlc-gwp-card')) return;
      var grid = document.querySelector('ul.collection-product-list');
      if (!grid) return;
      var cards = grid.querySelectorAll('li.collection-product-card');
      if (cards.length < 3) return;

      var gwp = document.createElement('div');
      gwp.className = 'tlc-gwp-card tlc-reveal-pending';

      var gwpLink = document.createElement('a');
      gwpLink.href = '/collections/gifts';
      gwpLink.className = 'tlc-gwp-card__inner';

      var icon = document.createElement('div');
      icon.className = 'tlc-gwp-card__icon';
      icon.textContent = '\uD83C\uDF81';

      var lbl = document.createElement('p');
      lbl.className = 'tlc-gwp-card__label';
      lbl.textContent = 'Free Gift Unlocked';

      var ttl = document.createElement('p');
      ttl.className = 'tlc-gwp-card__title';
      ttl.textContent = 'Spend \u20B9499 & a free gift is yours';

      var dsc = document.createElement('p');
      dsc.className = 'tlc-gwp-card__desc';
      dsc.textContent = 'Up to 4 gifts per order. No code needed \u2014 just add to cart.';

      var cta = document.createElement('div');
      cta.className = 'tlc-gwp-card__cta';
      cta.textContent = 'Shop & Unlock \u2192';

      gwpLink.appendChild(icon);
      gwpLink.appendChild(lbl);
      gwpLink.appendChild(ttl);
      gwpLink.appendChild(dsc);
      gwpLink.appendChild(cta);
      gwp.appendChild(gwpLink);

      cards[2].parentNode.insertBefore(gwp, cards[2].nextSibling);

      if (window.IntersectionObserver) {
        var gwpObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            e.target.classList.add('tlc-revealed');
            var t = e.target;
            setTimeout(function () { t.classList.remove('tlc-reveal-pending'); }, 650);
            gwpObs.unobserve(e.target);
          });
        }, { threshold: 0.06 });
        gwpObs.observe(gwp);
      }
    }

    /* ④ INLINE ATC — no-op for Stretch (quick-buy is already below the image) */
    function moveQuickBuy() { }

    /* ⑤ COLLECTION BAR — product count + filter pills + breadcrumb */
    function initCollectionBar() {
      var metaEl = document.getElementById('tlc-coll-meta');
      if (!metaEl) return;
      var meta;
      try { meta = JSON.parse(metaEl.textContent); } catch (e) { return; }

      var grid = document.querySelector('ul.collection-product-list');
      if (!grid) return;

      var bar = document.createElement('div');
      bar.className = 'tlc-coll-bar';

      /* Breadcrumb */
      var bc = document.createElement('nav');
      bc.className = 'tlc-breadcrumb';
      bc.setAttribute('aria-label', 'Breadcrumb');
      var homeA = document.createElement('a');
      homeA.href = '/';
      homeA.className = 'tlc-bc-link';
      homeA.textContent = 'Home';
      var sep = document.createElement('span');
      sep.className = 'tlc-bc-sep';
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = '/';
      var curr = document.createElement('span');
      curr.className = 'tlc-bc-curr';
      curr.setAttribute('aria-current', 'page');
      curr.textContent = meta.title;
      bc.appendChild(homeA);
      bc.appendChild(sep);
      bc.appendChild(curr);
      bar.appendChild(bc);

      /* Count + pills row */
      var row = document.createElement('div');
      row.className = 'tlc-coll-row';

      var countEl = document.createElement('span');
      countEl.className = 'tlc-prod-count';
      countEl.textContent = meta.count + ' products';
      row.appendChild(countEl);

      if (meta.tags && meta.tags.length) {
        var pills = document.createElement('div');
        pills.className = 'tlc-pills';
        pills.setAttribute('role', 'list');

        var allPill = document.createElement('a');
        allPill.href = meta.url;
        allPill.className = 'tlc-pill' + (meta.currentTags.length === 0 ? ' tlc-pill--active' : '');
        allPill.setAttribute('role', 'listitem');
        allPill.textContent = 'All';
        pills.appendChild(allPill);

        meta.tags.forEach(function (tag) {
          var pill = document.createElement('a');
          var slug = tag.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '');
          pill.href = meta.url + '/' + slug;
          var isActive = meta.currentTags.some(function (t) { return t === tag; });
          pill.className = 'tlc-pill' + (isActive ? ' tlc-pill--active' : '');
          pill.setAttribute('role', 'listitem');
          pill.textContent = tag;
          pills.appendChild(pill);
        });

        row.appendChild(pills);
      }

      bar.appendChild(row);
      grid.parentNode.insertBefore(bar, grid);
    }

    /* ⑥ BADGE COLORING — semantic color per badge text */
    function colorBadges() {
      document.querySelectorAll('.collection-product-card .badge').forEach(function (badge) {
        var text = badge.textContent.trim().toLowerCase();
        if (text.includes('gift') || text.includes('set')) {
          badge.classList.add('tlc-badge--gift');
        } else if (text.includes('new') || text.includes('launch')) {
          badge.classList.add('tlc-badge--new');
        } else if (text.includes('refill')) {
          badge.classList.add('tlc-badge--refill');
        } else if (text.includes('best') || text.includes('seller')) {
          badge.classList.add('tlc-badge--bestseller');
        } else if (text.includes('sale') || text.includes('off')) {
          badge.classList.add('tlc-badge--sale');
        }
      });
    }

    function boot() {
      var isCollection = document.body.classList.contains('template-collection');
      initScrollReveal();          /* runs on any page with product cards */
      if (isCollection) {
        injectGWPCard();
        tlcMasonry();
        initCollectionBar();
        colorBadges();
      }
      moveQuickBuy();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    if (document.body.classList.contains('template-collection')) {
      window.addEventListener('load', tlcMasonry);
      var rTimer;
      window.addEventListener('resize', function () {
        clearTimeout(rTimer);
        rTimer = setTimeout(tlcMasonry, 160);
      });
    }

  }());

(function () {

    /* ── Wishlist hearts ────────────────────────────────────────────────── */
    function initWishlistHearts() {
      if (document.querySelector('.tlc-wish-btn')) return;
      var stored = JSON.parse(localStorage.getItem('tlc_wl') || '[]');

      document.querySelectorAll('li.collection-product-card').forEach(function (card) {
        var mediaLink = card.querySelector('a.media');
        if (!mediaLink) return;

        var productLink = card.querySelector('a[href*="/products/"]');
        if (!productLink) return;

        var m = productLink.href.match(/\/products\/([^?#/]+)/);
        if (!m) return;
        var handle = m[1];

        var isWished = stored.indexOf(handle) > -1;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tlc-wish-btn' + (isWished ? ' tlc-wished' : '');
        btn.innerHTML = isWished ? '&#9829;' : '&#9825;';
        btn.setAttribute('aria-label', isWished ? 'Remove from wishlist' : 'Save to wishlist');
        btn.setAttribute('data-handle', handle);

        if (getComputedStyle(mediaLink).position === 'static') {
          mediaLink.style.position = 'relative';
        }
        mediaLink.appendChild(btn);

        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var list = JSON.parse(localStorage.getItem('tlc_wl') || '[]');
          var idx = list.indexOf(handle);
          if (idx > -1) {
            list.splice(idx, 1);
            btn.classList.remove('tlc-wished');
            btn.innerHTML = '&#9825;';
            btn.setAttribute('aria-label', 'Save to wishlist');
          } else {
            list.push(handle);
            btn.classList.add('tlc-wished');
            btn.innerHTML = '&#9829;';
            btn.setAttribute('aria-label', 'Remove from wishlist');
            btn.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.4)' }, { transform: 'scale(1)' }], { duration: 280, easing: 'ease-out' });
          }
          localStorage.setItem('tlc_wl', JSON.stringify(list));
        });
      });
    }

    /* ── Free gift urgency strip — REMOVED 2026-07-29 ─────────────────────
     * This injected "Spend ₹799+ and a free gift is automatically added to
     * your bag" above the grid on every collection page. Nothing ever did
     * that. Shopify's native BxGy only zeroes a gift the customer already
     * added — it never adds one — and no gift discount can apply at all while
     * the Monsoon 25% runs, because Shopify lands only one product discount
     * per line (tested 29 Jul: the gift was still charged in full). The ₹799
     * threshold matched no live offer either.
     * The gift ladder (₹599/₹899/₹1,399/₹1,899) is built and held for 29 Aug.
     * When it goes live, rebuild this strip reading the SAME thresholds as
     * snippets/tlc-gift-ladder.liquid so page and cart can never disagree.
     * See memory: project_gift_ladder_stacking_blocker.
     */
    function initUrgencyStrip() { /* intentionally disabled — see note above */ }

    /* ── Trust credential strip ─────────────────────────────────────────── */
    function initTrustStrip() {
      if (document.querySelector('.tlc-trust-strip')) return;
      var grid = document.querySelector('ul.collection-product-list');
      if (!grid) return;

      var items = [
        { icon: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>', label: 'Patch-test first' },
        { icon: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><path d="M8 12l3 3 5-5"/></svg>', label: 'Body-first formulas' },
        { icon: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>', label: 'Cruelty Free' },
        { icon: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>', label: 'Made in India' }
      ];

      var strip = document.createElement('div');
      strip.className = 'tlc-trust-strip';
      items.forEach(function (item) {
        var el = document.createElement('span');
        el.className = 'tlc-trust-item';
        el.innerHTML = item.icon + '<span>' + item.label + '</span>';
        strip.appendChild(el);
      });
      grid.parentNode.insertBefore(strip, grid);
    }

    /* ── Boot on collection pages ───────────────────────────────────────── */
    function bootCTR() {
      if (!document.body.classList.contains('template-collection')) return;
      initUrgencyStrip();
      initTrustStrip();
      initWishlistHearts();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootCTR);
    } else {
      bootCTR();
    }

  }());
